export const PROCESSES_AND_DOCUMENTS_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'draft',
  'public_agent_module_permission',
  'group_module_permission',
]
